/** @copy-from https://gitlab.poski.com/poskireal/poskireal.cz/-/blob/293bdfcb5009ad40d8d5f7ef6a550c59314e3034/frontend/CID/poski/v6.1/klasik/js/hlavni-menu-2.js */
// CESKA-REALITNI — hlavní menu toggle + telefonní disclosure (mobil + desktop).
// Přepisuje poski/klasik/js/hlavni-menu-2.js.
//
//   - Hamburger ikony: CeskaHamburger-icon (ne MaxxusHamburger-icon).
//   - Mobilní telefon disclosure (.HeaderMobilePhone, #JS-header-phone):
//       tap na .JS-phone-toggle toggleje panel (.is-revealed + aria-expanded).
//   - Desktop telefon disclosure (.HeaderPhoneTile, #JS-header-phone-desktop):
//       tap na .JS-phone-toggle-desktop toggleje panel; zavřít při outside-click.
//   - Oba panely se skryjí při otevření mobilního menu.
//   - PR-anchor a submenu logika zachována z maxxus.

document.addEventListener('DOMContentLoaded', () => {
	const hamburgers = document.querySelectorAll('.JS-hamburger');
	const menu = document.querySelector('.responsive-menu-holder');
	const clone = menu ? menu.querySelector('.efect-clone') : null;

	// --- Mobilní telefon disclosure --------------------------------
	const phoneContainer = document.getElementById('JS-header-phone');
	const phoneToggle = phoneContainer ? phoneContainer.querySelector('.JS-phone-toggle') : null;
	const phonePanel = phoneContainer ? phoneContainer.querySelector('.HeaderMobilePhone-panel') : null;

	const setPhoneRevealed = (revealed) => {
		if (!phonePanel || !phoneToggle) return;
		phonePanel.classList.toggle('is-revealed', revealed);
		phonePanel.setAttribute('aria-hidden', String(!revealed));
		phoneToggle.setAttribute('aria-expanded', String(revealed));
	};

	if (phoneToggle) {
		phoneToggle.addEventListener('click', () => {
			const nextState = !phonePanel?.classList.contains('is-revealed');
			setPhoneRevealed(nextState);
		});
	}

	// --- Desktop telefon disclosure --------------------------------
	const desktopPhoneContainer = document.getElementById('JS-header-phone-desktop');
	const desktopPhoneToggle = desktopPhoneContainer ? desktopPhoneContainer.querySelector('.JS-phone-toggle-desktop') : null;
	const desktopPhonePanel = desktopPhoneContainer ? desktopPhoneContainer.querySelector('.HeaderPhoneTile-panel') : null;

	const setDesktopPhoneRevealed = (revealed) => {
		if (!desktopPhonePanel || !desktopPhoneToggle) return;
		desktopPhonePanel.classList.toggle('is-revealed', revealed);
		desktopPhonePanel.setAttribute('aria-hidden', String(!revealed));
		desktopPhoneToggle.setAttribute('aria-expanded', String(revealed));
	};

	if (desktopPhoneToggle) {
		desktopPhoneToggle.addEventListener('click', (e) => {
			e.stopPropagation();
			const nextState = !desktopPhonePanel?.classList.contains('is-revealed');
			setDesktopPhoneRevealed(nextState);
		});
	}

	// Outside-click zavře desktop disclosure panel
	document.addEventListener('click', (e) => {
		if (desktopPhoneContainer && !desktopPhoneContainer.contains(e.target)) {
			setDesktopPhoneRevealed(false);
		}
	});

	// --- Menu toggle -----------------------------------------------
	if (!menu || !hamburgers.length) {
		return;
	}

	menu.querySelectorAll('.uroven-2').forEach(el => {
		const parent = el.parentNode;
		if (parent.querySelector(':scope > .PR-anchor')) {
			return;
		}
		const anchor = document.createElement('span');
		anchor.classList.add('PR-anchor');
		parent.insertBefore(anchor, parent.firstChild);
	});

	const anchors = menu.querySelectorAll('.PR-anchor');

	const setMenuOpen = (open) => {
		hamburgers.forEach(el => el.classList.toggle('is-active', open));
		menu.classList.toggle('is-active', open);
		document.body.classList.toggle('no-scroll', open);

		// Skrýt oba telefon disclosure panely při otevření/zavření menu (React parity)
		if (open) {
			setPhoneRevealed(false);
			setDesktopPhoneRevealed(false);
		}

		if (!open) {
			anchors.forEach(el => {
				el.classList.remove('is-active');
				if (el.parentElement) el.parentElement.classList.remove('is-active');
				const submenu = el.nextElementSibling?.nextElementSibling;
				if (submenu) submenu.classList.remove('is-active');
			});
		}
	};

	const toggleMenu = () => setMenuOpen(!menu.classList.contains('is-active'));

	hamburgers.forEach(el => el.addEventListener('click', toggleMenu));
	if (clone) clone.addEventListener('click', () => setMenuOpen(false));

	anchors.forEach(el => {
		el.addEventListener('click', e => {
			e.preventDefault();
			el.classList.toggle('is-active');
			if (el.parentElement) el.parentElement.classList.toggle('is-active');
			const submenu = el.nextElementSibling?.nextElementSibling;
			if (submenu) submenu.classList.toggle('is-active');
		});
	});

	// Klik na položku menu = zavřít overlay (mobile UX)
	menu.querySelectorAll('.menu.uroven-1 > li > a').forEach(link => {
		link.addEventListener('click', () => {
			if (menu.classList.contains('is-active')) setMenuOpen(false);
		});
	});

	// Reset při resizu zpět na desktop
	let lastIsMobile = window.matchMedia('(max-width: 63.99rem)').matches;
	window.addEventListener('resize', () => {
		const isMobile = window.matchMedia('(max-width: 63.99rem)').matches;
		if (lastIsMobile !== isMobile) {
			setMenuOpen(false);
			setPhoneRevealed(false);
			setDesktopPhoneRevealed(false);
			lastIsMobile = isMobile;
		}
	});
});
